import React, { useRef } from "react";
import { motion, useInView } from "framer-motion";
import OurStrengthImg from '../Img/Main_Img1_V9.png';
import AboutHomeClouds from '../Img/About_Home_clouds.png';

const subheading = "Our Strength";
const heading = "Trusted Workforce Solutions";

const paragraph =
    "At V9 Primeforce, our strength lies in our ability to deliver highly specialized staffing solutions across various industries. We align our recruitment strategy with client needs to ensure maximum impact.";


const strengths = [
    "Comprehensive talent acquisition strategy",
    "Global workforce deployment",
    "Industry-specific staffing solutions",
    "Commitment to compliance and quality",
    "Dedicated client and candidate support",
];

const splitWords = (text) => text.split(" ").map((word, i) => ({ word, key: i }));

const OurStrengthSection = () => {
    const textRef = useRef(null);
    const isInView = useInView(textRef, { once: true, margin: "-100px" });

    return (
        <div className="about-home-main-v9">
            <div className="about-home-wrapper-v9">
                 <motion.div
                    className="about-home-image-v9"
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={isInView ? { opacity: 1, scale: 1 } : {}}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                >
                    <img
                        src={OurStrengthImg}
                        alt="V9 Primeforce team at work"
                        className="about-home-img-v9"
                    />
                </motion.div>
                <motion.div
                    className="about-home-text-v9"
                    ref={textRef}
                    initial="hidden"
                    animate={isInView ? "visible" : "hidden"}
                    variants={{
                        visible: {
                            transition: {
                                staggerChildren: 0.06,
                            },
                        },
                    }}
                >
                    {/* Subheading */}
                    <motion.p className="about-home-subheading-v9">
                        {splitWords(subheading).map(({ word, key }) => (
                            <motion.span
                                key={`sub-${key}`}
                                className="about-home-heading-word-v9"
                                variants={{
                                    hidden: { opacity: 0, y: 15 },
                                    visible: { opacity: 1, y: 0 },
                                }}
                            >
                                {word}&nbsp;
                            </motion.span>
                        ))}
                    </motion.p>

                    {/* Heading */}
                    <motion.h2 className="about-home-heading-v9">
                        {splitWords(heading).map(({ word, key }) => (
                            <motion.span
                                key={`head-${key}`}
                                className="about-home-heading-word-v9"
                                variants={{
                                    hidden: { opacity: 0, y: 20 },
                                    visible: { opacity: 1, y: 0 },
                                }}
                            >
                                {word}&nbsp;
                            </motion.span>
                        ))}
                    </motion.h2>

                    {/* Paragraph 1 */}
                    <motion.p className="about-home-paragraph-v9">
                        {splitWords(paragraph).map(({ word, key }) => (
                            <motion.span
                                key={`para1-${key}`}
                                className="about-home-heading-word-v9"
                                variants={{
                                    hidden: { opacity: 0, y: 20 },
                                    visible: { opacity: 1, y: 0 },
                                }}
                            >
                                {word}&nbsp;
                            </motion.span>
                        ))}
                    </motion.p>

                    <motion.ul
                        className="about-home-paragraph-v9"
                        style={{ paddingLeft: "10px", margin: 0 }}
                        variants={{
                            hidden: { opacity: 0, y: 20 },
                            visible: { opacity: 1, y: 0 },
                        }}
                    >
                        {strengths.map((item, index) => (
                            <motion.li
                                key={`strength-${index}`}
                                className="about-home-heading-word-v9 strength-list-item-v9"
                                style={{ display: "block", marginBottom: "10px" }}
                                variants={{
                                    hidden: { opacity: 0, y: 20 },
                                    visible: { opacity: 1, y: 0 },
                                }}
                            >
                                {item}
                            </motion.li>
                        ))}
                    </motion.ul>
                </motion.div>
            </div>
            {/* <img src={AboutHomeClouds} alt="" className="about-home-clouds-v9" /> */}
        </div>
    );
};

export default OurStrengthSection;
